<template>
    <div class="a-modal">
        <div class="popup__header">
            <span class="title title--sm popup__title">{{ id ? $lang('admin.addMaster.title'): $lang('admin.addMaster.title2')}}</span>
        </div>
        <form class="form" ref="form" @submit.prevent="submit">
            <div class="popup__content">
                <div v-if="isAdmin" class="form__item form__item--inline">
                    <div class="a-modal__inner">
                        <span class="form__label">{{ $lang('admin.addMaster.partner') }}</span>
                        <el-popover v-model="errors.partner_id.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.partner_id.message">
                            <el-select filterable slot="reference"
                                       :class="{ 'add__error': errors.partner_id.isErrorPaint }"
                                       @focus="clearErrors"
                                       :placeholder="$lang('admin.addMaster.partner.select')"
                                       class="a-modal__small"
                                       v-model="form.partner_id"
                                       :loading-text="$lang('el-select.loading')"
                                       :noDataText="$lang('el-select.noDataText')"
                                       :noMatchText="$lang('el-select.noMatchText')"
                                       :disabled="!!id"
                                       required>
                                <el-option v-for="item in partners"
                                           :key="item.user.id"
                                           :label="item.number_name"
                                           :value="item.user.id">
                                </el-option>
                            </el-select>
                        </el-popover>
                    </div>
                    <span class="a-modal__right-hint a-modal__right-hint--small">{{ $lang('admin.addMaster.partner.hint') }}</span>
                </div>
                <div v-if="isAdmin" class="form__item form__item--inline">
                    <div class="a-modal__inner">
                        <span class="form__label">{{ $lang('admin.addMaster.toro') }}</span>
                        <el-popover v-model="errors.toro_id.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.toro_id.message">
                            <el-select filterable
                                       slot="reference"
                                       :class="{ 'add__error': errors.toro_id.isErrorPaint }"
                                       v-model="form.toro_id"
                                       required
                                       :disabled="!!id"
                                       @focus="clearErrors"
                                       @change="form.cemetery_id = null"
                                       :loading-text="$lang('el-select.loading')"
                                       :noDataText="$lang('el-select.noDataText')"
                                       :noMatchText="$lang('el-select.noMatchText')"
                                       :placeholder="$lang('admin.addMaster.toro.select')">
                                <el-option v-for="item in toros"
                                           :key="item.id"
                                           :label="item.title"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-popover>
                    </div>
                </div>
                <div v-if="isAdmin" class="form__item form__item--inline">
                    <div class="a-modal__inner">
                        <span class="form__label">{{ $lang('admin.addMaster.cemetery') }}</span>
                        <el-popover v-model="errors.cemetery_id.isError"
                                    trigger="manual"
                                    placement="top"
                                    width="300"
                                    popper-class="add__error-popover"
                                    :content="errors.cemetery_id.message">
                            <el-select filterable
                                       slot="reference"
                                       :class="{ 'add__error': errors.cemetery_id.isErrorPaint }"
                                       @focus="clearErrors"
                                       v-model="form.cemetery_id"
                                       :disabled="!cemeteries.length || !!id"
                                       :loading-text="$lang('el-select.loading')"
                                       :noDataText="$lang('el-select.noDataText')"
                                       :noMatchText="$lang('el-select.noMatchText')"
                                       :placeholder="$lang('admin.addMaster.cemetery.select')">
                                <el-option v-for="item in cemeteries"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-popover>
                    </div>
                </div>
                <div class="form__item">
                    <span class="form__label">{{ $lang('admin.addMaster.masterData') }}</span>
                    <el-popover v-model="errors.name.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.name.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.name.isErrorPaint }"
                                  @focus="clearErrors"
                                  :placeholder="$lang('admin.addMaster.name.placeholder')"
                                  class="input input--big"
                                  v-model="form.name"/>
                    </el-popover>
                    <span class="a-modal__hint">{{ $lang('admin.addMaster.name.hint') }}</span>
                </div>
                <div class="form__item a-modal__big">
                    <el-popover :value="errors.phone.isError || errors.phone_md5.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.phone.message || errors.phone_md5.message">
                        <input-phone slot="reference"
                                    :class="{ 'add__error': errors.phone.isErrorPaint || errors.phone_md5.isErrorPaint }"
                                    @focus="clearErrors"
                                     :placeholder="$lang('admin.addMaster.phone.placeholder')"
                                    class="input input--big"
                                    v-model="form.phone"/>
                    </el-popover>
                    <span class="a-modal__hint">{{ $lang('admin.addMaster.phone.hint') }}</span>
                </div>
                <div class="form__item a-modal__big">
                    <el-popover :value="errors.email.isError || errors.email_md5.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.email.message || errors.email_md5.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.email.isErrorPaint || errors.email_md5.isErrorPaint }"
                                  @focus="clearErrors"
                                  :placeholder="$lang('admin.addMaster.email.placeholder')"
                                  class="input input--big"
                                  v-model="form.email"/>
                    </el-popover>
                    <span class="a-modal__hint" v-if="!this.id">{{ $lang('admin.addMaster.email.hint') }}</span>
                </div>
                <div class="form__item a-modal__big" v-if="id">
                    <button class="btn btn--middle btn--main-bg" :disabled="disableSetPassword" @click.prevent="setNewPassword(userId)">{{ $lang('admin.addMaster.restoreButton') }}</button>
                </div>
            </div>
            <div class="popup__footer">
                <button class="btn btn--middle btn--main-bg">{{ $lang('admin.addMaster.save') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    import errors from '../../../mixins/errors';
    import userEdit from "../../../mixins/userEdit";
    import InputPhone from "../../../components/InputPhone";
    import Vue from "vue";

    export default {
        name: "AddMaster",
        mixins: [errors, userEdit],
        components: {InputPhone},
        data: () => ({
            isAdmin: window.laravel.isAdmin,
            isPartner: window.laravel.isPartner,
            user: window.laravel.user,
            userId: null,
            errors: {
                name: {
                    isError: false,
                    message: ''
                },
                email: {
                    isError: false,
                    message: ''
                },
                email_md5: {
                    isError: false,
                    message: ''
                },
                phone: {
                    isError: false,
                    message: ''
                },
                phone_md5: {
                    isError: false,
                    message: ''
                },
                partner_id: {
                    isError: false,
                    message: ''
                },
                toro_id: {
                    isError: false,
                    message: ''
                },
                cemetery_id: {
                    isError: false,
                    message: ''
                },
            }
        }),
        computed: {
            id() {
                return this.$route.params.id ?? null;
            },
            ...mapState('createMaster', {
                storeForm: state => state.form
            }),
            ...mapState('createMaster', [
                'partners',
                'toros',
                'cemeteries'
            ]),
            form: {
                get() {
                    return this.storeForm;
                },
                set(val) {
                    this.setForm(val);
                }
            }
        },
        mounted() {
            if (this.id) {
                this.getMaster(this.id)
                    .then((response) => {
                        this.userId = response.data.user.id;

                        let form = this.getDataObject(
                            ['id', 'name', 'email', 'phone', 'partner_id', 'toro_id', 'cemetery_id'],
                            response.data,
                            ['id', 'user.name', 'user.email', 'user.phone', 'user.partner_id', 'toro_id', 'cemetery_id']
                        );

                        this.$set(this, 'form', form);
                    })
            } else if (this.isPartner) {
                this.form.partner_id = this.user.id;
            }

             this.allPartners().then((response) => {
                 this.setPartners(response.data);
             });

            this.getAllToros().then((response) => {
                this.setToros(response.data);
            });
        },
        beforeDestroy() {
            if (this.id) {
                this.resetForm();
                this.setCemeteries([]);
            }
        },
        watch: {
            'form.toro_id': {
                handler() {
                    this.getAllCemeteries({toro_id: this.form.toro_id}).then((response) => {
                        this.setCemeteries(response.data)
                    });
                }
            }
        },
        methods: {
            ...mapActions('user', [
                'resetPassword',
            ]),
            ...mapActions('master', [
                'getMaster'
            ]),
            ...mapMutations('master', [
                'addMaster',
                'updateMasterState'
            ]),
            ...mapActions('partner', [
                'allPartners'
            ]),
            ...mapActions('pages', [
                'getAllToros',
                'getAllCemeteries'
            ]),
            ...mapActions('createMaster', [
                'createMaster',
                'editMaster',
                'resetForm'
            ]),
            ...mapMutations('createMaster', [
                'setForm',
                'setPartners',
                'setToros',
                'setCemeteries',
                'setFormPartnerId'
            ]),
            submit() {
                this.$loading(this.$optionsLoading);

                if (this.id) {
                    this.edit();
                } else {
                    this.create();
                }
            },
            create() {
                this.createMaster(this.form)
                    .then((response) => {
                        this.addMaster(response.data);
                        this.$appNotify.success(Vue.prototype.$lang('admin.addMaster.success'));
                        this.$router.push({name:'masters'});
                        this.resetForm();
                    }).catch((error) => {
                        this.createErrors(error.response.data.errors);
                    }).finally(() => {
                        this.$loading({}).close();
                    });
            },
            edit() {
                this.editMaster(this.form)
                    .then((response) => {
                        this.updateMasterState(response.data);

                        this.$appNotify.success(Vue.prototype.$lang('admin.addMaster.success'));
                        this.$router.push({name:'masters'});
                        this.resetForm();
                    }).catch((error) => {
                        this.createErrors(error.response.data.errors);
                    }).finally(() => {
                        this.$loading({}).close();
                    });
            },
        }
    }
</script>
